// hideTabButton: the flat export/PDF variant reuses these rows, but its
// "Details" tab is a dead control on paper.
const DetailsTable = ({ data, hideTabButton = false }) => {
  return (
    <>
      {hideTabButton ? null : (
        <div className="thunter-threat-details__table-button-block">
          <button className="thunter-threat-details__tab-button thunter-threat-details__tab-button__active">
            Details
          </button>
        </div>
      )}
      <div className="details-block">
        {Object.entries(data).map(([key, value], index) => (
          <div className="details-block__row" key={index}>
            <p className="details-block__row-item">{key}</p>
            <p className="details-block__row-item">{value}</p>
          </div>
        ))}
      </div>
    </>
  );
};

export default DetailsTable;
